// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pending Updates — compact fixed-height layout */

.pu-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 480px;
  max-height: calc(100vh - 88px);
  padding: 0 4px;
}

.pu-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  flex-shrink: 0;
}

.pu-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.pu-stat:hover {
  border-color: #cbd5e1;
}

.pu-stat--active {
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  border-color: #93c5fd;
}

.pu-stat--pending { border-bottom: 2px solid #eab308; }
.pu-stat--fetched { border-bottom: 2px solid #3b82f6; }
.pu-stat--applied { border-bottom: 2px solid #22c55e; }
.pu-stat--failed { border-bottom: 2px solid #ef4444; }

.pu-stat-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
}

.pu-stat-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 2px;
}

.pu-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.pu-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
  flex: 1 1;
}

.pu-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 12px;
  background: #fff;
  color: #475569;
}

.pu-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pu-btn-primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.pu-btn-primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.pu-btn-ghost {
  background: #f8fafc;
}

.pu-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.pu-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.pu-toast-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.pu-toast-success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.pu-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pu-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.pu-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.pu-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.pu-table thead th:last-child { width: 40px; }

.pu-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  color: #334155;
}

.pu-table tbody tr:hover {
  background: #f8fafc;
}

.pu-org-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pu-org-email {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pu-type {
  font-size: 13px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
}

.pu-type--license_extension {
  background: #eff6ff;
  color: #1d4ed8;
}

.pu-type--user_limits {
  background: #fdf2f8;
  color: #9d174d;
}

.pu-detail-text {
  font-size: 15px;
  color: #64748b;
}

.pu-status {
  font-size: 13px;
  font-weight: 600;
  text-transform: capitalize;
  padding: 3px 8px;
  border-radius: 999px;
}

.pu-status--pending { background: #fef9c3; color: #854d0e; }
.pu-status--fetched { background: #dbeafe; color: #1e40af; }
.pu-status--applied { background: #dcfce7; color: #166534; }
.pu-status--failed { background: #fee2e2; color: #991b1b; }

.pu-date {
  display: block;
  font-size: 15px;
  color: #475569;
}

.pu-by {
  display: block;
  font-size: 14px;
  color: #94a3b8;
  margin-top: 1px;
}

.pu-icon-delete {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pu-table tbody tr:hover .pu-icon-delete {
  color: #94a3b8;
}

.pu-icon-delete:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.pu-icon-delete:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.pu-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.pu-spin {
  animation: pu-spin 0.8s linear infinite;
}

@keyframes pu-spin {
  to { transform: rotate(360deg); }
}

/* Modal */
.pu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2100;
  padding: 16px;
}

.pu-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.pu-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.pu-modal-header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.pu-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pu-form-section {
  padding: 0 16px;
  margin-top: 14px;
}

.pu-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.pu-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  box-sizing: border-box;
}

.pu-hint {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 6px;
}

.pu-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 16px;
  margin-top: 14px;
}

.pu-form-row .pu-form-section {
  padding: 0;
  margin-top: 0;
}

.pu-client-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px;
}

.pu-no-clients {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.pu-client-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.pu-client-card:hover {
  background: #f8fafc;
}

.pu-client-card-selected {
  background: #eff6ff;
  border-color: #93c5fd;
}

.pu-client-card-org {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.pu-client-card-email {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
}

.pu-client-card-expiry {
  font-size: 14px;
  font-weight: 600;
  color: #059669;
  background: #ecfdf5;
  padding: 2px 7px;
  border-radius: 999px;
  flex-shrink: 0;
}

.pu-expiry-warn {
  color: #dc2626;
  background: #fef2f2;
}

.pu-type-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.pu-type-btn {
  padding: 9px 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  color: #64748b;
}

.pu-type-btn-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

.pu-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px 16px;
  margin-top: 8px;
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 768px) {
  .pu-page {
    height: auto;
    max-height: none;
  }

  .pu-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .pu-table-scroll {
    max-height: 420px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PendingUpdatesPage.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA,oBAAoB,gCAAgC,EAAE;AACtD,oBAAoB,gCAAgC,EAAE;AACtD,oBAAoB,gCAAgC,EAAE;AACtD,mBAAmB,gCAAgC,EAAE;;AAErD;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,gCAAgC,WAAW,EAAE;;AAE7C;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Pending Updates — compact fixed-height layout */\n\n.pu-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 480px;\n  max-height: calc(100vh - 88px);\n  padding: 0 4px;\n}\n\n.pu-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.pu-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.pu-stat:hover {\n  border-color: #cbd5e1;\n}\n\n.pu-stat--active {\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n  border-color: #93c5fd;\n}\n\n.pu-stat--pending { border-bottom: 2px solid #eab308; }\n.pu-stat--fetched { border-bottom: 2px solid #3b82f6; }\n.pu-stat--applied { border-bottom: 2px solid #22c55e; }\n.pu-stat--failed { border-bottom: 2px solid #ef4444; }\n\n.pu-stat-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.1;\n}\n\n.pu-stat-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-top: 2px;\n}\n\n.pu-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.pu-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n  flex: 1;\n}\n\n.pu-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 12px;\n  background: #fff;\n  color: #475569;\n}\n\n.pu-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pu-btn-primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.pu-btn-primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.pu-btn-ghost {\n  background: #f8fafc;\n}\n\n.pu-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.pu-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.pu-toast-error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.pu-toast-success {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.pu-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.pu-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.pu-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.pu-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pu-table thead th:last-child { width: 40px; }\n\n.pu-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n  color: #334155;\n}\n\n.pu-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.pu-org-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pu-org-email {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pu-type {\n  font-size: 13px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.pu-type--license_extension {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.pu-type--user_limits {\n  background: #fdf2f8;\n  color: #9d174d;\n}\n\n.pu-detail-text {\n  font-size: 15px;\n  color: #64748b;\n}\n\n.pu-status {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: capitalize;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.pu-status--pending { background: #fef9c3; color: #854d0e; }\n.pu-status--fetched { background: #dbeafe; color: #1e40af; }\n.pu-status--applied { background: #dcfce7; color: #166534; }\n.pu-status--failed { background: #fee2e2; color: #991b1b; }\n\n.pu-date {\n  display: block;\n  font-size: 15px;\n  color: #475569;\n}\n\n.pu-by {\n  display: block;\n  font-size: 14px;\n  color: #94a3b8;\n  margin-top: 1px;\n}\n\n.pu-icon-delete {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pu-table tbody tr:hover .pu-icon-delete {\n  color: #94a3b8;\n}\n\n.pu-icon-delete:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.pu-icon-delete:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.pu-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.pu-spin {\n  animation: pu-spin 0.8s linear infinite;\n}\n\n@keyframes pu-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Modal */\n.pu-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2100;\n  padding: 16px;\n}\n\n.pu-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 480px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.pu-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pu-modal-header h2 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.pu-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pu-form-section {\n  padding: 0 16px;\n  margin-top: 14px;\n}\n\n.pu-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 6px;\n}\n\n.pu-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  box-sizing: border-box;\n}\n\n.pu-hint {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 6px;\n}\n\n.pu-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  padding: 0 16px;\n  margin-top: 14px;\n}\n\n.pu-form-row .pu-form-section {\n  padding: 0;\n  margin-top: 0;\n}\n\n.pu-client-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.pu-no-clients {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.pu-client-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.pu-client-card:hover {\n  background: #f8fafc;\n}\n\n.pu-client-card-selected {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.pu-client-card-org {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pu-client-card-email {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n}\n\n.pu-client-card-expiry {\n  font-size: 14px;\n  font-weight: 600;\n  color: #059669;\n  background: #ecfdf5;\n  padding: 2px 7px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.pu-expiry-warn {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n.pu-type-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.pu-type-btn {\n  padding: 9px 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.pu-type-btn-active {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.pu-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px 16px;\n  margin-top: 8px;\n  border-top: 1px solid #f1f5f9;\n}\n\n@media (max-width: 768px) {\n  .pu-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .pu-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .pu-table-scroll {\n    max-height: 420px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
